import { type ReactNode, createContext, useContext, useEffect, useMemo } from 'react'
import { type ComplianceLayerStore } from 'pages/settings/pages/compliance/store/complianceLayerStore'
import { InternationalStepsStore } from 'pages/settings/pages/compliance/pages/international/store/internationalStepsStore'

const InternationalStepsContext = createContext<InternationalStepsStore | null>(null)

export const useInternationalStepsContext = () => {
  const context = useContext(InternationalStepsContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with InternationalStepsProvider'
    )

  return context
}

export const InternationalStepsProvider = ({
  complianceLayerStore,
  children,
}: {
  complianceLayerStore: ComplianceLayerStore
  children: ReactNode
}) => {
  const store = useMemo(
    () => new InternationalStepsStore(complianceLayerStore),
    [complianceLayerStore]
  )

  useEffect(() => {
    return () => {
      store.internationalRegulatoryBundlesStore.showErrorsBanner()
      store.dispose()
    }
  }, [store])

  return (
    <InternationalStepsContext.Provider value={store}>
      {children}
    </InternationalStepsContext.Provider>
  )
}
